import { render, staticRenderFns } from "./AdvancePay.vue?vue&type=template&id=b2da7fa2"
import script from "./AdvancePay.vue?vue&type=script&lang=js"
export * from "./AdvancePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports